import { fetcher } from "helpers/fetcher";

import { TGetStaffIdCardRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffIdCard = async (userId: string) => {
  return await fetcher<TGetStaffIdCardRes, any>(
    ENDPOINT.USER.GET_STAFF_ID_CARD,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_STAFF_ID_CARD.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffIdCard = async (userId: string) => {
  return (await getStaffIdCard(userId)).data;
};

queryGetStaffIdCard._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_ID_CARD.url,
  userId,
];
